export function CreateCastSubmit(directorEnArr, directorteArr) {
  const director2 = directorEnArr.map((directorItem, directorIndex) => {
    if (Object.keys(directorItem).some(key => key === 'personID')) {
      if (directorItem.personID) {
        return {
          // newPerson: directorItem.newPerson,
          // PK: directorItem.PK,
          // SK: directorItem.SK,
          roleName_En: directorItem.roleName_En,
          roleName_Te: directorItem.roleName_Te
            ? directorItem.roleName_Te
            : directorteArr[directorIndex]
            ? directorteArr[directorIndex]
            : '',
          personID: directorItem.personID,
          // personUUID: directorItem.personUUID,
        }
      }

      return {
        // newPerson: directorItem.newPerson,
        name_En: directorItem.name_En,
        name_Te: directorItem.name_Te,
        roleName_En: directorItem.roleName_En,
        roleName_Te: directorItem.roleName_Te
          ? directorItem.roleName_Te
          : directorteArr[directorIndex]
          ? directorteArr[directorIndex]
          : '',
      }
    }

    return {
      // newPerson: directorItem.newPerson,
      name_En: directorItem.name_En,
      name_Te: directorItem.name_Te,
      roleName_En: directorItem.roleName_En,
      roleName_Te: directorItem.roleName_Te
        ? directorItem.roleName_Te
        : directorteArr[directorIndex]
        ? directorteArr[directorIndex]
        : '',
    }
  })
  const director = director2.map((e, index) => ({
    ...e /* , roleName_Te: directorteArr[index] */,
    weight: index + 1,
  }))

  return director
}
